import { render, staticRenderFns } from "./FormEdit.vue?vue&type=template&id=6fd72f60&scoped=true"
import script from "./FormEdit.vue?vue&type=script&lang=js"
export * from "./FormEdit.vue?vue&type=script&lang=js"
import style0 from "./FormEdit.vue?vue&type=style&index=0&id=6fd72f60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd72f60",
  null
  
)

export default component.exports